import CustomerSupport from '../../src/legacy/CustomerSupport';
export default CustomerSupport;
